import React from 'react';

const SearchInput = React.memo(({ 
  value, 
  onChange, 
  onFocus, 
  onBlur, 
  inputRef, 
  placeholder = "Search..." 
}) => {
  return (
    <div className="relative flex-1 min-w-0">
      <svg className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
      </svg>
      <input
        ref={inputRef}
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onFocus={onFocus}
        onBlur={onBlur}
        className="pl-10 pr-4 py-2 w-full border border-gray-300 dark:border-slate-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 min-w-0 bg-base-100 text-base-content placeholder:text-base-content/50"
      />
    </div>
  );
});

SearchInput.displayName = 'SearchInput';

export default SearchInput;
